export default __webpack_public_path__ + "static/media/hht2_sitcom_16.78661cc4.png";